function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  id: "ant-design:partition-outlined"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M12.5117 8.39453H17.5332C17.6875 8.39453 17.8125 8.26953 17.8125 8.11523V3.0918C17.8125 2.9375 17.6875 2.8125 17.5332 2.8125H12.5117C12.3574 2.8125 12.2324 2.9375 12.2324 3.0918V4.90625H9.58203C9.50586 4.90625 9.44336 4.96875 9.44336 5.04492V9.37109H7.76953V7.48633C7.76953 7.33203 7.64453 7.20703 7.49023 7.20703H2.4668C2.3125 7.20703 2.1875 7.33203 2.1875 7.48633V12.5098C2.1875 12.6641 2.3125 12.7891 2.4668 12.7891H7.48828C7.64258 12.7891 7.76758 12.6641 7.76758 12.5098V10.625H9.44141V14.9512C9.44141 15.0273 9.50391 15.0898 9.58008 15.0898H12.2305V16.9043C12.2305 17.0586 12.3555 17.1836 12.5098 17.1836H17.5312C17.6855 17.1836 17.8105 17.0586 17.8105 16.9043V11.8848C17.8105 11.7305 17.6855 11.6055 17.5312 11.6055H12.5117C12.3574 11.6055 12.2324 11.7305 12.2324 11.8848V13.8379H10.6973V6.16211H12.2324V8.11523C12.2324 8.26953 12.3574 8.39453 12.5117 8.39453ZM13.5566 4.13867H16.4863V7.07031H13.5566V4.13867ZM6.44336 11.4648H3.51367V8.53516H6.44336V11.4648ZM13.5566 12.9316H16.4863V15.8633H13.5566V12.9316Z",
  fill: "#365DE6"
}));
const SvgPartition = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPartition, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/partition.d76fc209.svg";
export { ForwardRef as ReactComponent };